<div class="lds-container h250 mt-2 SD-graph-main-avg">
  <!-- <div class="SD-graph" #graph>
  <mat-slide-toggle *ngIf="octopusUser" (change)="octopusToggle($event)">Octopus Energy</mat-slide-toggle>
  <lds-progress-spinner *ngIf="loading"></lds-progress-spinner>
</div> -->
<canvas id="averageEnergy" [hidden]="loading">{{graph}}</canvas>
@if (loading) {
  <lds-progress-spinner></lds-progress-spinner>
}
</div>
